import React from 'react';
import { useTheme } from 'styled-components';
import { AvailabilityIndicator } from '../../../logic/Models/Responses/SeedResponseV7';
import { ReactComponent as GreenAvailabilityIcon } from '../../../assets/images/AvailabilityIcons/Green.svg';
import { ReactComponent as YellowAvailabilityIcon } from '../../../assets/images/AvailabilityIcons/Yellow.svg';
import { ReactComponent as RedAvailabilityIcon } from '../../../assets/images/AvailabilityIcons/Red.svg';

/** General availability Icon. TODO: Actually use this everywhere as needed. */
export const AvailabilityIcon = (props: { availability: AvailabilityIndicator, style?: React.CSSProperties }) =>
{
	const theme = useTheme();
	const availability = props.availability;
	
	return <div style={{
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		...props.style,
	}}>
		{availability === 'Green' ? <GreenAvailabilityIcon style={{ fill: theme.colors.availabilityGreen }} />
			: availability === 'Yellow' ? <YellowAvailabilityIcon style={{ fill: theme.colors.availabilityYellow }} />
				: availability === 'Red' ? <RedAvailabilityIcon style={{ fill: theme.colors.availabilityRed }} />
					: availability === 'None' ? <RedAvailabilityIcon style={{ fill: theme.colors.availabilityRed }} />
						: <React.Fragment />
		}
	</div>;
};